export default __webpack_public_path__ + "locales/fr/ChangeUserStatusDialog.json?hash=75e73b400684d4125f61690682c9d654";